import HeaderBar from "./HeaderBar";
import ClientApp from "./ClientApp";
import React from "react";
import Constants from "@/constants";
import LiveApp from "./LiveApp";
import { useCurTab } from "@/hooks";
import GlobalTransition from "@/components/GlobalTransition";
import Bg from "@/components/Bg";
import classnames from "classnames";

interface IWebPageProps {
  isLoading: boolean;
}
const WebPage: React.FC<IWebPageProps> = ({ isLoading }) => {
  const [curTab, setCurTab] = useCurTab();
  const [isBigScreen, setIsBigScreen] = React.useState(true);
  React.useEffect(() => {
    const handleResize = () => {
      setIsBigScreen(window.innerWidth >= 1240);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <GlobalTransition isLoading={isLoading} />
      {!isLoading && (
        <>
          <Bg isLive={curTab === Constants.ETabKey.LIVE_APP} />
          <div className="relative mx-auto flex h-full w-full max-w-[1920px] flex-col overflow-hidden pt-[40px]">
            <div className={classnames("z-10", isBigScreen ? "px-[100px]" : "px-[40px]")}>
              <HeaderBar tabList={Constants.TAB_LIST} curTab={curTab} setCurTab={setCurTab} />
            </div>
            {curTab === Constants.ETabKey.CLIENT_APP ? (
              <ClientApp isBigScreen={isBigScreen} />
            ) : (
              <LiveApp isBigScreen={isBigScreen} />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default WebPage;
